import { CSSProperties } from 'react'

import { StyleSetting } from '@types'

export const convertStyleSettingToCss = (
  styleSetting?: StyleSetting
): CSSProperties | undefined => {
  if (!styleSetting) {
    return undefined
  }

  const { settingText } = styleSetting

  return {
    backgroundColor: styleSetting.background,
    fontFamily: settingText.fontFamily,
    fontSize: `${settingText.fontSize}px`,
    fontWeight: `${settingText.isBold ? 'bold' : 'normal'}`,
    fontStyle: `${settingText.isItalic ? 'italic' : 'normal'}`,
    color: `${settingText.fontColor}`,
    border: `1px solid ${styleSetting.settingBorder.color}`,
    textAlign: settingText.alignment,
    justifyContent: settingText.alignment,
  }
}
